import { FunctionComponent } from 'react';
import styles from './NoPromocodes.module.scss';
import clsx from 'clsx';
import Button from 'components/UI/V3/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBadgePercent } from '@fortawesome/pro-solid-svg-icons/faBadgePercent';
import { useHistory } from 'react-router-dom';
import { MarketingPromoCodes } from 'routes/Paths';

interface NoPromocodesProps {
    className?: string;
    onClick?: () => void;
}

export const NoPromocodes: FunctionComponent<NoPromocodesProps> = props => {
    const history = useHistory();

    const clickHandler = () => {
        history.push(MarketingPromoCodes);
    };

    return (
        <div className={clsx(styles.container, props.className)}>
            <FontAwesomeIcon
                icon={faBadgePercent}
                className={styles.icon}
            />
            <span className={styles.title}>No Promo Codes Added Yet</span>
            <span className={styles.description}>Click the “Add Promo Code” button to add your first one.</span>
            <Button
                label="+ Add Promo Code"
                variant="green"
                onClick={clickHandler}
                size="large"
                className={styles.button}
            />
        </div>
    );
};

export default NoPromocodes;
